// extracted by mini-css-extract-plugin
export default {"notepad":"style_notepad__8f+0x","title":"style_title__ODOtV","textList":"style_textList__opgf8"};